<template>
  <select :name="name" class="form-control" style="width: 100%">
    <option v-for="item in data" :value="item.id" selected="selected">{{ item.company_address.company }}</option>
  </select>
</template>

<script>
require('select2/dist/js/select2.full');

export default {

  name: 'vToken2',

  data() {
    return {
      defaultOptions: {
        minimumInputLength: 1,
        allowClear: true,
        cache: true,
        multiple: true,

        ajax: {
          url: '/api/proxify/domains/prismatic/gallery-search/tokenizer',
          dataType: 'json',
          delay: 100,
          data(params) {
            return {
              phrase: params.term
            }
          },
          processResults(data, params) {
            return { results: data };
          },
        },
        templateResult(item) {

          if (item.loading) {
            return item.text;
          }
          return `
                          <span class="${item.type}">${item.label}</span>
                      `;
        },
        templateSelection(item) {
          return `
                          <span class="${item.type}">${item.label}</span>
                  `;
        },
        escapeMarkup(markup) {
          return markup;
        }
      }
    }
  },

  props: {
    options: {
      type: Object
    },
    name: {
      type: String
    },
    data: {
      type: Array,
      default: function () { return [] }
    }
  },

  mounted() {

    let options = Object.assign(this.defaultOptions, this.options);

    let $searchBox = $(this.$el);

    $searchBox.select2(options);
    if (this.name === 'applicators') {
      $searchBox.prop('readonly', true);
    }
    $searchBox.on('select2:select', (item) => {
      $searchBox.val('').trigger('change');
      this.$emit('token2-select', item.params.data);
      $searchBox.select2('destroy');
      $searchBox.select2(options);
    });

    if (this.data.length) {
      $searchBox.val(this.data.map(item => item.id)).trigger('change');
    }
    let vm = this;

    $searchBox.on('change', function (event) {
      vm.$emit('input', $searchBox.select2('data'));
    });
  },

}
</script>
